$(document).ready(function () {
  replays();
});

function applyStoredState() {
  const state = localStorage.getItem('variantToggleState');

  // 👉 if last action was MINUS → do nothing (as you requested)
  if (state !== 'expanded') return;

  const isMobile = window.innerWidth < 768;
  const hiddenClass = isMobile ? 'is-hidden-option-mob' : 'is-hidden-option';

  const $fieldset = $('fieldset.product-form__input');
  if (!$fieldset.length) return;

  const $minus = $fieldset.find('.minussssssss');

  const $plus = $minus
    .prevAll('label.forcolorplusiconss.plusssssss:visible')
    .first();

  // ✅ SHOW ALL (simulate PLUS click)
  $fieldset.removeClass('removeplus').addClass('visibleminus');
  $fieldset.find('label').removeClass(hiddenClass);
}

function replays() {
  setInterval(function () {
    var video = $('.video_conttt .variant-video')[0];
    
    if (video && video.paused) {
      video.play();
    }
  }, 3000);
}

$(document).on('keyup', '.product-engraving-wrapper input.engraving-field', function () {
  $('input.engarving[name="properties[Personalize Message]"]').attr('value',$(this).val());
});

function caratonly(){
 var checkedd =  $('fieldset.js.product-form__input.product-form__input--pill[selected-val="Center Carat Weight"] input:checked').val();
 $('.product .selectedcaratvall').html(checkedd);
}


var variantSwitchTimer = null;
function handleVariantChange() {
  if (variantSwitchTimer) {
    clearTimeout(variantSwitchTimer);
  }
  variantSwitchTimer = setTimeout(function () {
    var selectedValues = [];
    var allSelected = true;
    $('.product-form__input--pill').each(function () {
      var checked = $(this).find('input[type=radio]:checked');
      if (checked.length) {
        selectedValues.push($.trim(checked.val()));
      } else {
        allSelected = false;
      }
    });
    if (!allSelected) return;
    var productData = $('.optionscontainerproduct').attr('data-variants');
    if (!productData) return;
    var variants = JSON.parse(productData);
    var matchedVariant = variants.find(function (variant) {
      return variant.options.every(function (optionValue, index) {
        return $.trim(optionValue) === selectedValues[index];
      });
    });
    if (matchedVariant && matchedVariant.id) {
      updateVariantMediaGallery(matchedVariant.id);
    }
  }, 60);
}

$(document).on(
  'change',
  'body .product-form__input--pill input[type=radio]',
  function () {
    handleVariantChange(); // your existing logic
  }
);


// let lastSelectedColor = null;

// $(document).on(
//   'change',
//   'body[page-type="rings"] .product-form__input--pill input[type=radio]',
//   function () {

//     const el = document.querySelector('.optionscontainerproduct');
//     if (!el) return;

//     const variants = JSON.parse(el.dataset.variants || '[]');
//     let selectedValues = [];
//     let allSelected = true;
//     $('.product-form__input--pill').each(function () {
//       const checked = $(this).find('input[type=radio]:checked');
//       if (checked.length) {
//         selectedValues.push($.trim(checked.val()));
//       } else {
//         allSelected = false;
//       }
//     });
//     if (!allSelected) return;
//     const matchedVariant = variants.find(function (variant) {
//       return variant.options.every(function (optionValue, index) {
//         return $.trim(optionValue) === selectedValues[index];
//       });
//     });

//     if (!matchedVariant) return;

//     const currentColor = matchedVariant.option1;

//     // ✅ ONLY trigger when color changes
//     if (lastSelectedColor !== currentColor) {
//       lastSelectedColor = currentColor;

//       const colorVariantId = colorVariantMap[currentColor];

//       if (colorVariantId) {
//         updateVariantMediaGallery(colorVariantId);
//       }
//     }
//   }
// );

$(document).on('click', '.product-form__input--pill label', function () {
  var input = $(this).find('input[type=radio]');
  if (input.length) {
    input.prop('checked', true).trigger('change');
  }
});

var variantTitleMap = {};

$(document).ready(function () {
  $('.variant-media-data').each(function () {
    var title = $(this).attr('variant_title');
    var id = $(this).data('variant-id');
    if (title && id) {
      variantTitleMap[$.trim(title)] = id;
    }
  });
});
   
 
function attachShapeToMedia() {
  console.log('attachShapeToMedia',attachShapeToMedia);
  $('script.variant-media-data').each(function () {
    var shapeNum = $(this).attr('data-shape-num');
    var selectedColor = $(this).attr('data-selected-color');
    var variantId = $(this).data('variantId');

    $('ul.ullalighnes li.product__media-item.slider__slide[data-variant-group="' + variantId + '"]')
      .attr('data-shape-num', shapeNum)
      .attr('data-selected-color', selectedColor); // ✅ FIXED
  });
}

function rendernewLi(){
$('.product .grid__item.product__media-wrapper .slider-mobile-gutter ul.ullalighnes').append('<li class="product__media-item slider__slide activee"><img src="https://cdn.shopify.com/s/files/1/0766/9986/1205/files/Group_269.png?v=1775740268" alt="Image"></li>');
}


function buildAllVariantMedia() {
  const gallery = document.querySelector('.ullalighnes');
  if (!gallery) return;

  const variantScripts = document.querySelectorAll('.variant-media-data');
  if (!variantScripts.length) return;

  const fragment = document.createDocumentFragment();

  variantScripts.forEach((script, variantIndex) => {
    let mediaList = [];

    try {
      mediaList = JSON.parse(script.textContent.trim()) || [];
    } catch (e) {
      console.error('Invalid JSON in variant-media-data');
      return;
    }

    const variantId = script.dataset.variantId;
    const featuredVideo = script.getAttribute('featured-video');
    const endVideo = script.getAttribute('end-video');

    let isFirst = variantIndex === 0;

    // Featured video FIRST
    if (featuredVideo) {
      const li = createVideoNode(featuredVideo, isFirst);

      li.classList.add('featured-variant-video');
      li.setAttribute('data-variant-group', variantId);

      if (variantIndex !== 0) {
        li.style.display = 'none';
      }

      fragment.appendChild(li);
      isFirst = false;
    }

    // End video SECOND
    if (endVideo) {
      const li = createVideoNode(endVideo, isFirst);

      li.classList.add('end-variant-video');
      li.setAttribute('data-variant-group', variantId);

      if (variantIndex !== 0) {
        li.style.display = 'none';
      }

      fragment.appendChild(li);
      isFirst = false;
    }

    // Images & remaining media AFTER videos
    mediaList.forEach((item) => {
      if (!item || !item.src) return;

      let li = null;

      if (item.type === 'image') {
        li = createImageNode(item.src, isFirst);
      } else if (item.type === 'video') {
        li = createVideoNode(item.src, isFirst);
      }

      if (!li) return;

      li.setAttribute('data-variant-group', variantId);

      if (variantIndex !== 0) {
        li.style.display = 'none';
      }

      fragment.appendChild(li);
      isFirst = false;
    });
  });

  gallery.innerHTML = '';
  gallery.appendChild(fragment);

  refreshDawnGallery();
  attachShapeToMedia();
}



function playAllVariantVideos() {
$('li.product__media-item.end-variant-video.activee.featuredblock video')
  .get(0)
  ?.play();
}

function ensureEndVariantActive(delay = 0) {
  setTimeout(function () {
    const $items = $('li.end-variant-video');

    if (!$items.hasClass('activee')) {
      $items.eq(0).addClass('activee featuredblock');
    } else {
      console.log('Already added');
    }
    playAllVariantVideos()
  }, delay);
}

function updateVariantMediaGallery(variantId) {
  const gallery = document.querySelector('.ullalighnes');
  if (!gallery) return;
  const allItems = gallery.querySelectorAll('li[data-variant-group]');
  allItems.forEach(li => {
    li.style.display = 'none';
    li.classList.remove('activee');
  });
  const activeItems = gallery.querySelectorAll(
    `li[data-variant-group="${variantId}"]`
  );
  activeItems.forEach(li => {
    li.style.display = '';
    li.classList.add('activee');
  });

  refreshDawnGallery();
  activateVariantVideos(variantId);
  ensureEndVariantActive(100); 
}

function getVariantinfo(variantId) {
  visibleproduct(variantId);
  var completedata = $('.optionscontainerproduct').attr('data-variants');
  if (!completedata) return;

  var pvariants = JSON.parse(completedata);
  var findd = pvariants.find(v => v.id == variantId);

  if (!findd) return;

  var optionm = findd.option1 || '';
  var optionsku = findd.sku || '';

  if (optionm.includes('14k') || optionm.includes('18k')) {
    optionm = optionm.replace('14k ', '').replace('18k ', '');
  }

  if (optionm) {
    $('.accordion__content dl.ProductAttributes-AttributeContainer dd.selectedvariatnmetal')
      .html(optionm);
  }
  var dataTitle = $('fieldset.product-form__input--pill.optiondata-1 span.selectedvarian').html();
  var skuUp = optionsku;
  if(!skuUp){
   skuUp = '';
  }
  if(!dataTitle){
   dataTitle = '';
  }
  $('body.colorvariants span.metalType span.metalentered').html(dataTitle);
  $('body.colorvariants span.forsku span.valueentered').html(skuUp);
  if (optionsku) {
    $('.accordion__content dl.ProductAttributes-AttributeContainer dd.selectedvarintsku')
      .html(optionsku);
  }
}

function createImageNode(src, isFirst) {
  const li = document.createElement('li');
  li.className = `product__media-item slider__slide${isFirst ? ' is-active' : ''}`;

  const img = document.createElement('img');
  img.src = src;
  img.srcset = buildSrcSet(src);
  img.loading = 'eager';
  img.alt = '';
  img.style.width = '100%';
  img.style.height = 'auto';
  li.appendChild(img);
  return li;
}

function createVideoNode(src, isFirst) {
  const li = document.createElement('li');
  li.className = `product__media-item video_container_slides slider__slide${isFirst ? ' is-active' : ''}`;

  const video = document.createElement('video');
  video.className = 'variant-video';

  // Only first visible video should preload
  video.preload = isFirst ? 'metadata' : 'none';

  video.muted = true;
  video.loop = true;
  video.playsInline = true;

  // Only autoplay first visible
  if (isFirst) {
    video.autoplay = true;
  }

  video.style.width = '100%';
  video.style.height = 'auto';
  video.style.objectFit = 'cover';

  // ⚡ Use src directly (faster than source tag)
  video.src = src;
  
  li.appendChild(video);

  return li;
}

function activateVariantVideos(variantId) {
  console.log('vvvideooo',variantId);
  document.querySelectorAll('.variant-video').forEach(video => {
    const parent = video.closest('[data-variant-group]');
    
    if (parent && parent.dataset.variantGroup == variantId) {
      if (!video.src) {
        video.src = video.dataset.src;
      }
      video.play().catch(()=>{});
    } else {
      video.pause();
    }
  });
}



function buildSrcSet(src) {
  if (!src.includes('/cdn/shop/')) return '';
  const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1646, 1946];
  return widths.map(w => `${src}&width=${w} ${w}w`).join(', ');
}

function refreshDawnGallery() {
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const firstMedia = mediaGallery.querySelector('.product__media-item');
  if (firstMedia && mediaGallery.setActiveMedia) {
    mediaGallery.setActiveMedia(firstMedia, true);
  }

  mediaGallery.dispatchEvent(new Event('change'));
}



const metafieldsEl = document.getElementById('variant-metafields-data');

if (!metafieldsEl) {
  console.warn('Variant metafields JSON not found');
} else {
  try {
    window.variantMetafieldsData = JSON.parse(metafieldsEl.textContent);
  } catch (e) {
    console.error('Invalid variant metafields JSON', e);
  }
}



function renderVariantMetafields(variantId) {
  if (!window.variantMetafieldsData) return;

  const data = window.variantMetafieldsData[variantId];
  const container = document.getElementById('variant-metafields-render');
  const containerSS = document.querySelector('.certified_center_diamond');
  const breaking = document.querySelector('.backking');

  if (!container || !data) {
    if (container) container.innerHTML = '';
    return;
  }

  
  if (breaking){
  const breakingDiamonds = [

    { label: 'custom_backing', value: data.custom_backing }

  ];

  const cbreakingDia = breakingDiamonds
    .filter(f => f.value && f.value.trim() !== '')
    .map(f => `<span class="${f.label}">Backing: ${f.value}</span>`)
    .join('');

  if (cbreakingDia) {
       breaking.innerHTML = cbreakingDia;
  }
  else{
    breaking.innerHTML = '';
  }
  }

  if (containerSS){
  const centerDiamonds = [

    { label: 'center_black_diamond', value: data.certified_center_diamond },
    { label: 'excellent_cut',  value: data.excellent_cut_details }

  ];

  // const centerDia = centerDiamonds
  //   .filter(f => f.value && f.value.trim() !== '')
  //   .map(f => `<p class="${f.label}">
  //   ${f.value
  //   .replace(/\b\d+(\.\d+)?\s*ct\.?\b/gi, '')
  //   .replace(/\s+/g, ' ')
  //   .trim()}
  //   </p>`)
  //   .join('');

  // const centerDia = centerDiamonds
  // .filter(f => f.value && f.value.trim() !== '')
  // .map(f => `<p class="${f.label}">
  //   ${f.value
  //     .replace(/\b\d+(\.\d+)?\s*ct\.?\b/gi, '')
  //     .replace(/\./g, '')
  //     .replace(/\s+/g, ' ')
  //     .trim()}
  //   </p>`)
  // .join('');

   const centerDia = centerDiamonds
  .filter(f => f.value && f.value.trim() !== '')
  .map(f => `<span class="${f.label}">
    ${f.value
      .replace(/(?<=\D)\.(?=\d)/g, '')
      .replace(/\.(?=\D|$)/g, '')
      .replace(/\s+/g, ' ')
      .trim()}
  </span>`)
  .join(',');

  if (centerDia) {
       containerSS.innerHTML = centerDia;
  }
  else{
    containerSS.innerHTML = '';
  }
  }

   const centerStoneFieldsSS = [
    { label: 'Diamond Type', value: data._center_diamond },
    { label: 'Shape', value: data._center_shape },
    { label: 'Approximate Carat Weight', value: data._center_weight },
    { label: 'Average Color', value: data._center_color },
    { label: 'Average Clarity', value: data._center_clarity },
    { label: 'Certification', value: data._center_certifications },
    { label: 'Setting', value: data._center_setting }
  ];

  const centerStoneFields = [
    { label: 'Diamond Type', value: data.center_stone_diamond },
    { label: 'Shape', value: data.center_stone_shape },
    { label: 'Approximate Carat Weight', value: data.center_stone_weight },
    { label: 'Average Color', value: data.center_stone_color },
    { label: 'Average Clarity', value: data.center_stone_clarity },
    { label: 'Certification', value: data.center_stone_clarification },
    { label: 'Setting', value: data.center_stone_setting }
  ];

  const sideStoneFields = [
    { label: 'Diamond Type', value: data.side_stone_diamond },
    { label: 'Shape', value: data.side_stone_shape },
    { label: 'Approximate Carat Weight', value: data.side_stone_weight },
    { label: 'Average Color', value: data.side_stone_color },
    { label: 'Average Clarity', value: data.side_stone_clarity },
    { label: 'Certification', value: data.side_diamond_certification },
    { label: 'Setting', value: data.side_stone_setting }
  ];
 
 

  let html = '';

    const centerLists = centerStoneFieldsSS
    .filter(f => f.value && f.value.trim() !== '')
    .map(f => `<li><strong>${f.label}:</strong> <span>${f.value}</span></li>`)
    .join('');

  if (centerLists) {
    html += `
      <div class="variant-block">
        <h3 class="detailsheading">Stone Details</h3>
        <ul class="ulheading">
          ${centerLists}
        </ul>
      </div>
    `;
  }


  const centerList = centerStoneFields
    .filter(f => f.value && f.value.trim() !== '')
    .map(f => `<li><strong>${f.label}:</strong> <span>${f.value}</span></li>`)
    .join('');

  if (centerList) {
    html += `
      <div class="variant-block">
        <h3 class="detailsheading">Center Stone Details</h3>
        <ul class="ulheading">
          ${centerList}
        </ul>
      </div>
    `;
  }

  const sideList = sideStoneFields
    .filter(f => f.value && f.value.trim() !== '')
    .map(f => `<li><strong>${f.label}:</strong> <span>${f.value}</span></li>`)
    .join('');

  if (sideList) {
    html += `
      <div class="variant-block">
        <h3 class="detailsheading">Side Stone Details</h3>
        <ul class="ulheading">
          ${sideList}
        </ul>
      </div>
    `;
  }

  container.innerHTML = html;
}

function loaderonload(){
return;
$('body.colorvariants .grid__item.product__media-wrapper media-gallery slider-component').addClass('loaderrrpro');
setTimeout(function() {
$('body.colorvariants .grid__item.product__media-wrapper media-gallery slider-component').removeClass('loaderrrpro');
}, 500);
}


function loaderr(){
  let gallerys = document.querySelector('.ullalighnes');
  if (!gallerys) return;
  gallerys.innerHTML = '';
}
 
function visibleproduct(ID){
renderVariantMetafields(ID);
$('.RecommendedBridalSets , .variant-meta-media').removeClass('matched');
$('.RecommendedBridalSets[varinttt="'+ID+'"] , .variant-meta-media[data-variant-id="'+ID+'"]').addClass('matched');
// $('.RecommendedBridalSets.matched').slick('refresh');
$('body.colorvariants .grid__item.product__media-wrapper media-gallery slider-component ul').removeClass('loaderrr');
}


$(document).ready(function () {
  var IDDD = $('.product .product__info-wrapper.grid__item input.product-variant-id').attr('value');
  getVariantinfo(IDDD);
  visibleproduct(IDDD);
  loaderonload();
  buildAllVariantMedia();
  updateVariantMediaGallery(IDDD);
});

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        getVariantinfo(variantId);
        applyStoredState();
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        return false;
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
